import { render, staticRenderFns } from "./StorageOut.vue?vue&type=template&id=2b75e27d&scoped=true&"
import script from "./StorageOut.vue?vue&type=script&lang=js&"
export * from "./StorageOut.vue?vue&type=script&lang=js&"
import style0 from "./StorageOut.vue?vue&type=style&index=0&id=2b75e27d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b75e27d",
  null
  
)

export default component.exports